const LandingHeadingText =({children, additionalclasses}) => {
    return (
        <p className={`text-[28px] lg:text-[36px] leading-[36px] font-semibold text-[#101010] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
}
export default LandingHeadingText;